/**
 * アラートラベル
 */

const typeToLabel = {
  0: 0, // 定休日の設定
  1: 1, // 人数オーバー
  2: 2, // 予約の重複
  3: 0, // ウェイティングの予約数オーバー
  4: 8, // 席が未指定の未確定予約
  5: 3, // IVR予約登録時
  6: 4, // 予約連携
  7: 4, // 他社取り込み登録
  8: 5, // 他店舗からの予約
  9: 4, // POS＋連携
  10: 6, // 外国版予約をキャンセル
  11: 6, // 法人予約をキャンセル
  12: 6, // 連携解除時の未確定予約の確定
  13: 6, // 連携解除時の未確定予約のキャンセル
  14: 6, // 異なる予約受付枠のテーブルを追加
  15: 7, // オリジナル予約登録
  16: 4, // 他社取り込み変更
  17: 6, // 他社取り込みキャンセル
  21: 6, // セールスフォース予約を変更
  22: 6, // セールスフォース予約をキャンセル
  23: 6, // 連携切替によってネット予約が未指定に変更
  24: 4, // レスラク予約新規登録
  25: 4, // レスラク予約変更
  26: 6, // レスラク予約キャンセル
  27: 6, // レスラク卓連携削除
  28: 6, // レスラクAPI取得エラー
  29: 0, // テーブル紐付け未設定時
  30: 6, // テーブル紐付け一時解除時
  31: 6, // ラ・クーポン利用不可通知
  32: 6, // ブロックと重複
  33: 8, // レスラク経由のリクエスト予約取り込み
  34: 6, // レスラク経由のリクエスト予約処理失敗
  35: 4, // レスラク経由のリクエスト予約処理成功
  36: 6, // レスラク経由のリクエスト予約（問い合わせ予約）台帳起因の処理失敗
  37: 6, // キャンセル処理台帳起因のエラー
  38: 6, // キャンセル処理レスラク起因のエラー
  39: 6, // キャンセル処理ぐるなびネット予約エンドユーザーによる
}

export default {
  namespaced: true,
  state: {
    byId: {
      0: '未設定',
      1: '要変更',
      2: '重複',
      3: 'TEL',
      4: '連携',
      5: '他店',
      6: '注意',
      7: '予約',
      8: '未確定',
    },
  },
  getters: {
    get: ({ byId }) => type => byId[typeToLabel[type] || 0],
  },
}
